import React from 'react';
import { Grid } from '@material-ui/core';
import Proptypes from 'prop-types';
import FormSection from '../../../../components/FormComponents/FormSection';
import TextInputFieldWithValidation from '../../../../components/ValidationFormElements/TextInputFieldWithValidation';
import MainRadio from '../../../../components/MUI/MainRadio';
import LoanExistingIcon from '../../../../img/formSectionIcons/loanExists.svg';

const LoanExisting = ({
  loanAgreementExists,
  handleLoanAgreementExists,
  formProps: { errors, register, clearError },
}) => (
  <FormSection title="propertyClaim.accInfo.loanAgreementExists" icon={LoanExistingIcon}>
    <Grid container spacing={4}>
      <Grid
        item
      >
        <MainRadio
          name="loanAgreementExists"
          labelKey="propertyClaim.accInfo.yes"
          value={loanAgreementExists}
          checked={!!loanAgreementExists}
          onChange={() => handleLoanAgreementExists(true)}
        />
      </Grid>
      <Grid item>
        <MainRadio
          name="loanAgreementExists"
          labelKey="propertyClaim.accInfo.no"
          value={loanAgreementExists}
          checked={!loanAgreementExists}
          onChange={() => handleLoanAgreementExists(false)}
        />
      </Grid>
    </Grid>
    {loanAgreementExists && (
      <Grid container spacing={4}>
        <Grid item xs={12} sm={4} md={6}>
          <TextInputFieldWithValidation
            name="loanCompanyName"
            labelKey="propertyClaim.accInfo.loanCompanyName"
            register={register}
            autoComplete="off"
            formProps={{ errors, clearError }}
          />
        </Grid>
      </Grid>
    )}
  </FormSection>
);

LoanExisting.propTypes = {
  formProps: Proptypes.shape({
    errors: Proptypes.shape({}),
    register: Proptypes.func,
    clearError: Proptypes.func,
  }).isRequired,
  loanAgreementExists: Proptypes.bool,
  handleLoanAgreementExists: Proptypes.func.isRequired,
};

LoanExisting.defaultProps = {
  loanAgreementExists: null,
};

export default LoanExisting;
